import React, { useState } from 'react';

import './GuessButton.css'

import { useDispatch, useSelector } from 'react-redux';

import { guessStory, setFeedbackModalContent } from '../../../redux/features/gameSlice'

import { CONFIG } from '../../../util/constants';
import { buildShareText } from './buildShareText';

const GuessButton = (props) => {
  // Refactor into share and guess button separate
  const dispatch = useDispatch();
  const { guessable, gameOver, incorrectGuesses, time, modal, score, won = true, shareImageBlob } = props;
  const [buttonLabel, setButtonLabel] = useState<string | null>(null);
  const referralCode = useSelector((state: any) => state.profileReducer.referralCode);
  const performanceUpdateStreak = useSelector(
    (state: any) => state.gameReducer.performanceUpdate?.currentStreak
  );
  const persistedStreak = useSelector(
    (state: any) => state.userPerformanceReducer.currentStreak
  );
  const streak = performanceUpdateStreak || persistedStreak;
  const className = `guess-button ${guessable || gameOver ? 'guessable' : ''} ${modal ? 'modal' : ''}`;
  const url = CONFIG.WEB_APP_URI + (referralCode ? `?referralCode=${referralCode}` : '');

  const flashLabel = (label: string) => {
    setButtonLabel(label);
    setTimeout(() => setButtonLabel(null), 1500);
  };

  const confirmFeedback = (message: string) => {
    flashLabel(message);
    dispatch(setFeedbackModalContent({
      feedbackModalContent: message,
      style: 'ephemeral',
      type: 'correct-guess',
    }));
  };

  const shareTextOnly = (title: string, text: string) => {
    if (navigator.share) {
      navigator.share({ title, text, url }).catch((err) => {
        if (err?.name !== 'AbortError') console.error(err);
      });
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(`${text}\n${url}`)
        .then(() => confirmFeedback('Copied to clipboard!'))
        .catch(console.error);
    }
  };

  const handleGuessClick = async () => {
    if (gameOver) {
      const { title, text } = buildShareText({ won, score, time, incorrectGuesses, streak });

      if (!shareImageBlob) {
        shareTextOnly(title, text);
        return;
      }

      const file = new File([shareImageBlob], 'newsie-result.png', { type: 'image/png' });
      if ((navigator as any).canShare?.({ files: [file] })) {
        navigator.share({ files: [file], title, text, url } as any).catch((err) => {
          if (err?.name !== 'AbortError') console.error(err);
        });
        return;
      }
      if (navigator.share) {
        shareTextOnly(title, text);
        return;
      }

      // Desktop without Web Share API: download the image, opportunistically
      // copy it to the clipboard too, and fall back to copying text+url.
      const imageUrl = URL.createObjectURL(shareImageBlob);
      const a = document.createElement('a');
      a.href = imageUrl;
      a.download = 'newsie-result.png';
      a.click();
      URL.revokeObjectURL(imageUrl);

      try {
        await (navigator.clipboard as any).write([
          new (window as any).ClipboardItem({ 'image/png': shareImageBlob }),
        ]);
        confirmFeedback('Image downloaded & copied!');
      } catch {
        navigator.clipboard?.writeText(`${text}\n${url}`)
          .then(() => confirmFeedback('Image downloaded!'))
          .catch(() => flashLabel('Image downloaded!'));
      }
    }
    else if (guessable) {
      dispatch(guessStory());
    }
  };
  return (<button className={className} onClick={handleGuessClick}>{buttonLabel || (gameOver ? 'Share' : 'Guess')}</button>)
};

export default GuessButton;